module.exports = __webpack_public_path__ + "static/media/silk-rhodes.106e4c9c.jpg";